import { produce } from 'immer';

import {
  createUser,
  deleteUser,
  assignUserRolesToApplication,
  getUserRolesByApplication,
  removeUserFromApplication,
  getUserRole,
  editUserRole,
} from './actions';

export const initialState = {
  // v2 states
  createUser: {
    loading: false,
    loaded: false,
    error: null,
    data: null,
  },

  deleteUser: {
    loading: false,
    loaded: false,
    error: null,
  },

  assignUserRolesToApplication: {
    loading: false,
    loaded: false,
    error: null,
  },

  removeUserFromApplication: {
    loading: false,
    loaded: false,
    error: null,
  },

  userRolesByApplication: {
    loading: false,
    loaded: false,
    error: null,
    data: null,
  },

  // Legacy v1 states
  userRole: {
    loading: false,
    loaded: false,
    error: null,
    list: [],
  },

  editUserRole: {
    loading: false,
    loaded: false,
    error: null,
  },
};

const reducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      // Create User
      case createUser.REQUEST:
        draft.createUser.loading = true;
        draft.createUser.loaded = false;
        draft.createUser.error = null;
        draft.createUser.data = null;
        break;

      case createUser.SUCCESS:
        draft.createUser.loading = false;
        draft.createUser.loaded = true;
        draft.createUser.data = payload;
        break;

      case createUser.FAILURE:
        draft.createUser.loading = false;
        draft.createUser.loaded = false;
        draft.createUser.error = payload;
        break;

      case createUser.RESET:
        draft.createUser = { ...initialState.createUser };
        break;

      // Delete User
      case deleteUser.REQUEST:
        draft.deleteUser.loading = true;
        draft.deleteUser.loaded = false;
        draft.deleteUser.error = null;
        break;

      case deleteUser.SUCCESS:
        draft.deleteUser.loading = false;
        draft.deleteUser.loaded = true;
        break;

      case deleteUser.FAILURE:
        draft.deleteUser.loading = false;
        draft.deleteUser.loaded = false;
        draft.deleteUser.error = payload;
        break;

      case deleteUser.RESET:
        draft.deleteUser = { ...initialState.deleteUser };
        break;

      // Assign User Roles to Application
      case assignUserRolesToApplication.REQUEST:
        draft.assignUserRolesToApplication.loading = true;
        draft.assignUserRolesToApplication.loaded = false;
        draft.assignUserRolesToApplication.error = null;
        break;

      case assignUserRolesToApplication.SUCCESS:
        draft.assignUserRolesToApplication.loading = false;
        draft.assignUserRolesToApplication.loaded = true;
        break;

      case assignUserRolesToApplication.FAILURE:
        draft.assignUserRolesToApplication.loading = false;
        draft.assignUserRolesToApplication.loaded = false;
        draft.assignUserRolesToApplication.error = payload;
        break;

      case assignUserRolesToApplication.RESET:
        draft.assignUserRolesToApplication = { ...initialState.assignUserRolesToApplication };
        break;

      // Remove User from Application
      case removeUserFromApplication.REQUEST:
        draft.removeUserFromApplication.loading = true;
        draft.removeUserFromApplication.loaded = false;
        draft.removeUserFromApplication.error = null;
        break;

      case removeUserFromApplication.SUCCESS:
        draft.removeUserFromApplication.loading = false;
        draft.removeUserFromApplication.loaded = true;
        break;

      case removeUserFromApplication.FAILURE:
        draft.removeUserFromApplication.loading = false;
        draft.removeUserFromApplication.loaded = false;
        draft.removeUserFromApplication.error = payload;
        break;

      case removeUserFromApplication.RESET:
        draft.removeUserFromApplication = { ...initialState.removeUserFromApplication };
        break;

      // Get User Roles by Application
      case getUserRolesByApplication.REQUEST:
        draft.userRolesByApplication.loading = true;
        draft.userRolesByApplication.loaded = false;
        draft.userRolesByApplication.error = null;
        draft.userRolesByApplication.data = null;
        break;

      case getUserRolesByApplication.SUCCESS:
        draft.userRolesByApplication.loading = false;
        draft.userRolesByApplication.loaded = true;
        draft.userRolesByApplication.data = payload;
        break;

      case getUserRolesByApplication.FAILURE:
        draft.userRolesByApplication.loading = false;
        draft.userRolesByApplication.loaded = false;
        draft.userRolesByApplication.error = payload;
        break;

      case getUserRolesByApplication.RESET:
        draft.userRolesByApplication = { ...initialState.userRolesByApplication };
        break;

      // Legacy v1: Get User Role
      case getUserRole.REQUEST:
        draft.userRole.loading = true;
        draft.userRole.loaded = false;
        draft.userRole.error = null;
        draft.userRole.list = [];
        break;

      case getUserRole.SUCCESS:
        draft.userRole.loading = false;
        draft.userRole.loaded = true;
        draft.userRole.list = payload;
        break;

      case getUserRole.FAILURE:
        draft.userRole.loading = false;
        draft.userRole.loaded = false;
        draft.userRole.error = payload;
        break;

      case getUserRole.RESET:
        draft.userRole = { ...initialState.userRole };
        break;

      // Legacy v1: Edit User Role
      case editUserRole.REQUEST:
        draft.editUserRole.loading = true;
        draft.editUserRole.loaded = false;
        draft.editUserRole.error = null;
        break;

      case editUserRole.SUCCESS:
        draft.editUserRole.loading = false;
        draft.editUserRole.loaded = true;
        break;

      case editUserRole.FAILURE:
        draft.editUserRole.loading = false;
        draft.editUserRole.loaded = false;
        draft.editUserRole.error = payload;
        break;

      case editUserRole.RESET:
        draft.editUserRole = { ...initialState.editUserRole };
        break;

      default:
        return draft;
    }
  });

export default reducer;
